// extracted by mini-css-extract-plugin
export default {"oneTimePinCode":"oneTimePinCode_neO4rTt","resendOneTimePinCode":"resendOneTimePinCode_ljwA2Cj"};